<template>
  <div class>
    <div>
      <div class="show-state">
        <a-button-group>
          <a-button
            size="small"
            v-for="(item, index) in showTag"
            @click="editShowState(index)"
            :type="item.state == 1 ? 'primary' : ''"
            :key="index"
            style="margin-right: 0"
            >{{ item.label }}</a-button
          >
        </a-button-group>
      </div>
      <div style="padding: 0 10px">
        <a-input-search
          style="margin: 8px 0"
          placeholder="输入标题的一部分或全部搜索"
          v-model="searchValue"
          enter-button="查询"
          @search="onSearch"
        ></a-input-search>
      </div>
      <div style="padding: 0 10px">
        <a-table
          :columns="columns"
          :dataSource="lists"
          :pagination="pagination"
          :rowKey="(record) => record.id"
          :loading="loding"
          size="small"
          @change="handleTableChange"
          :customRow="customRow"
        >
          <template slot="tableTitle" slot-scope="text">
            <span class="table-title">{{ intercept(text) }}</span>
          </template>
          <template slot="type" slot-scope="text, record">
            <span v-if="record.headpic.length > 0 && record.linkurl == ''"
              >图片</span
            >
            <span v-if="record.linkurl != ''">外链</span>
            <span v-if="(record.headpic.length = 0 && record.linkurl == '')"
              >普通</span
            >
          </template>
          <template slot="audit" slot-scope="text, record">
            <span v-if="text == 1">草稿</span>
            <span
              v-if="text > 1 && text < 99 && record.can_audit === true"
              class="warn"
              >审核中</span
            >
            <span
              v-if="text > 1 && text < 99 && record.can_audit === false"
              class="disable"
              >审核中</span
            >
            <span v-if="text == 100" class="success">已发布</span>
            <span v-if="text == 99" class="error">已退回</span>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: true,
    key: 'id'
  },
  {
    title: '文章标题',
    dataIndex: 'title',
    key: 'title',
    scopedSlots: { customRender: 'tableTitle' },
    width: '300px'
  },
  {
    title: '文章类型',
    scopedSlots: { customRender: 'type' },
    key: 'type',
    align: 'center'
  },
  {
    title: '发布时间',
    key: 'pubtime',
    sorter: true,
    dataIndex: 'pubtime'
  },
  {
    title: '发布人',
    key: 'truename',
    dataIndex: 'truename'
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'audit' }
  }
];
export default {
  components: {},
  data() {
    return {
      columns,
      lists: [],
      loding: false,
      pagination: {
        pageSize: 20
      },
      searchValue: '',
      showTag: [
        { type: 1, label: '待审', state: 1 },
        { type: 2, label: '已审', state: 1 },
        { type: 3, label: '草稿', state: 1 },
        { type: 4, label: '我的', state: 0 }
      ],
      param: {
        page: 1,
        limit: 20,
        title: '',
        catid: '',
        order: 'id',
        ordertype: 'desc'
      },
      catidValue: 'a'
    };
  },
  props: ['catid'],
  watch: {
    catid(value) {
      if (value != 0) {
        this.param.catid = value;
        this.searchValue = '';
        this.param.title = '';
        this.getLists();
      }
    }
  },
  methods: {
    editShowState(i) {
      this.showTag[i].state = this.showTag[i].state == 1 ? 0 : 1;
      this.setShowTag();
      this.param.page = 1;
      // if (this.catidValue == 'a') {
      //   this.param.catid = 0;
      // } else if (this.catidValue == 'b') {
      //   this.param.catid = this.catid;
      // }
      this.param.catid = this.catid;
      this.getLists();
    },
    customRow(record) {
      return {
        on: {
          // 事件
          click: event => {
            this.getPreview(record.id);
          } // 点击行
        }
      };
    },
    setShowTag() {
      window.localStorage.setItem('showTag', JSON.stringify(this.showTag));
    },
    getLists() {
      this.loding = true;
      let type = new Array();
      for (const item of this.showTag) {
        type.push(item.state);
      }
      this.param.show = type.join('');
      this.$http.post('/api/content/cloudlist', this.param).then(res => {
        if (res.data.state == 200) {
          const pagination = { ...this.pagination };

          for (let i in res.data.data) {
            let pic = [];
            if (
              res.data.data[i].headpic === null ||
              res.data.data[i].headpic == '[]'
            ) {
              pic = new Array();
            } else {
              if (res.data.data[i].headpic.indexOf(',') > 0) {
                pic = JSON.parse(res.data.data[i].headpic);
              } else {
                pic.push(res.data.data[i].headpic);
              }
            }
            res.data.data[i].headpic = pic;
          }
          pagination.total = res.data.pages * 20;
          this.lists = res.data.data;
          this.pagination = pagination;
        } else {
          this.lists = [];
        }
        this.loding = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.param.order = sorter.field;
      this.param.ordertype = sorter.order == 'ascend' ? 'asc' : 'desc';
      this.getLists();
    },
    onSearch(value) {
      this.searchValue = value;
      this.param.page = 1;
      this.param.title = value;
      // if (this.catidValue == 'a') {
      //   this.param.catid = 0;
      // } else if (this.catidValue == 'b') {
      //   this.param.catid = this.catid;
      // }
      this.param.catid = this.catid;
      this.getLists();
    },
    getPreview(id) {
      this.$emit('getdetails', id);
    },
    intercept(text) {
      let html = text;
      if (text.length > 30) {
        html = html.substr(0, 30) + '...';
      }
      return html;
    },
    catidType(e) {
      this.catidValue = e.target.value;
    }
  },
  created() {
    if (
      window.localStorage.getItem('showTag') != null &&
      window.localStorage.getItem('showTag') != ''
    ) {
      this.showTag = JSON.parse(window.localStorage.getItem('showTag'));
    } else {
      this.setShowTag();
    }
  },
  mounted() { }
};
</script>
<style scoped>
.show-state {
  border-bottom: 1px solid #e8e8e8;
  padding: 0 12px 8px 10px;
  margin: 15px 0px 8px 0;
  text-align: left;
}
.error {
  color: #f5222d;
}
.success {
  color: #52c41a;
}
.warn {
  color: #faad14;
}
.disable {
  color: #ddd;
}
.table-title {
  color: #041aed;
  cursor: pointer;
}
</style>
